import { render, staticRenderFns } from "./lottery-error-block.vue?vue&type=template&id=10889ecc&scoped=true&lang=pug&"
import script from "./lottery-error-block.vue?vue&type=script&lang=js&"
export * from "./lottery-error-block.vue?vue&type=script&lang=js&"
import style0 from "./lottery-error-block.vue?vue&type=style&index=0&id=10889ecc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10889ecc",
  null
  
)

export default component.exports